import React from "react";
import moment from "moment";
import ReactTable from "react-table";
import matchSorter from "match-sorter";

class CierreCajaCentralizado extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cajas: [],
            columns: [],
            isLoading: false,
            fecha: this.formatMomentForInput(moment())
        }


        this.formatAmount = this.formatAmount.bind(this);
    }

    formatAmount = (amount) => {
        let monto = parseFloat(amount);
        if (isNaN(monto)) {
            monto = 0;
        }

        const formattedMonto = monto.toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })

        return `S/ ${formattedMonto}`;
    }
    
    componentDidMount = async () => {
        this.setState({
            isLoading: true
        });

        this.fetchTurnos();
    }

    fetchTurnos = async () => {
        const req = await fetch(`/api/cajas/cajas-sucursal?fecha=${this.state.fecha}`);
        const data = await req.json();
        this.setState({
            cajas: data,
            isLoading: false
        });
    }

    formatMomentForInput = (momentDate) => {
        return momentDate.format("YYYY-MM-DD");
    }

    onChangeFecha = (e) => {
        this.setState({
            fecha: e.target.value
        }, () => {
            this.fetchTurnos();
        });

    }

    render(){
        return (
            <section className="ventas-fpay-section-vh pt-5">
                <div className="container">
                    <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2">
                        <span className="align-self-center letra-fecha-fpay">
                            Fecha:
                        </span>

                        <input  type="date"
                                className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                                name="fecha"
                                onChange={this.onChangeFecha}
                                value={this.state.fecha}/>

                    </div>
                    <ReactTable
                        id="table-productos-to-xls"
                        data={this.state.cajas}
                        pages={-1}
                        loading={this.state.isLoading}
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value
                        }
                        manual={true}
                        filterable={true}
                        sortable={true}
                        columns={[
                            {
                                columns: [
                                    {
                                        Header: "Caja",
                                        id: "Caja",
                                        width: 120,
                                        accessor: d => d.NombreCaja,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Caja"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Usuario",
                                        id: "Usuario",
                                        width: 130,
                                        accessor: d => d.NombreUsuario,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Usuario"]}),
                                        filterAll: true
                                    },
                                    {
                                        id: 'FechaInicio',
                                        Header: 'Fecha Inicio',
                                        width: 200,
                                        accessor: d => d.FechaInicio
                                    },
                                    {
                                        id: 'FechaCierre',
                                        Header: 'Fecha Cierre',
                                        width: 200,
                                        accessor: d => d.FechaFin || "En curso"
                                    },
                                    {
                                        id: "MontoInicial",
                                        Header: "Monto apertura",
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoInicial)
                                    },
                                    {
                                        id: 'total',
                                        Header: 'Total a entregar',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalEfectivoSistema)
                                    },
                                    {
                                        Header: "Efectivo",
                                        id: "Efectivo",
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalEfectivoSistema),
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Efectivo"]}),
                                        filterAll: true
                                    },
                                    {
                                        id: 'YAPE',
                                        Header: 'YAPE',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalYape)
                                    },
                                    {
                                        id: 'Plin',
                                        Header: 'Plin',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalPlin)
                                    },
                                    {
                                        id: 'POS',
                                        Header: 'POS',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalTarjetaVisaSistema)
                                    },
                                    {
                                        id: 'OtraTarjeta',
                                        Header: 'Otra Tarjeta',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalOtraTarjetaSistema)
                                    }
                                ]
                            }
                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        previousText="Anterior"
                        nextText="Siguiente"
                        noDataText="No se encontraron registros"
                        loadingText="Cargando..."
                        ofText="de"
                        rowsText="filas"
                        pageText="Página"
                        pageSizeOptions={[10, 20, 25, 50, 100]}
                    />
                </div>
            </section>
        );
    }
}

export default CierreCajaCentralizado;